import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './DateOfBirthScreen.module.css';
import { TMobileSignupForm } from '../../form/form';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-687. Day / month / year. Reads/writes the shared mobile signup form
// store (DIT-664). The 18+ requirement is stated in the sub-heading; the CTA
// only checks the date is well-formed (matches FoundingDateScreen).
export const DateOfBirthScreen = () => {
  const { t } = useLingui();
  const { register, watch } = useFormContext<TMobileSignupForm>();

  const day = watch('dobDay');
  const month = watch('dobMonth');
  const year = watch('dobYear');
  const isValid =
    /^\d{1,2}$/.test(day) && /^\d{1,2}$/.test(month) && /^\d{4}$/.test(year);

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your date of birth`}
      subHeading={t`You must be at least 18 years old.`}
      ctaDisabled={!isValid}
    >
      <div className={styles.row}>
        <Input
          {...register('dobDay')}
          label={t`Day`}
          placeholder={t`DD`}
          inputMode="numeric"
          maxLength={2}
        />
        <Input
          {...register('dobMonth')}
          label={t`Month`}
          placeholder={t`MM`}
          inputMode="numeric"
          maxLength={2}
        />
        <Input
          {...register('dobYear')}
          label={t`Year`}
          placeholder={t`YYYY`}
          inputMode="numeric"
          maxLength={4}
        />
      </div>
    </StepLayout>
  );
};
